let modalInstance;
let warningModalInstance;
let $modal;

$(document).ready(function (){
    const section = $('.gift-course-button').data('section')
    $(document).on('click', '.gift-course-button', function () {
        const $this = $(this)
        const action = $this.data('action') || 'direct'
        $modal = $("#gift-course-modal")
        modalInstance = new Modal($modal)

        if (action === 'add_gift_to_cart_item') {
            const itemId = $this.data('item_id')
            $modal.find('form').attr('action', '/carts/items/' + itemId + '/gift')

        } else {
            const productId = $this.data('product_id')
            $modal.find('form').attr('action', '/carts/'+productId+'/add-gift')
        }

        modalInstance.show()
    })

    $(document).on('change', '.gift-course-checkbox', function () {
        const $this = $(this)
        const checked = $this.prop('checked')
        const $modal = $("#gift-course-modal")
        itemId = $this.data('item_id')
        modalInstance = new Modal($modal)

        if (checked) {
            $modal.find('form').attr('action', '/carts/items/' + itemId + '/gift')
            modalInstance.show()
            $modal.on('hidden.bs.modal', function (event) {
                $this.prop('checked', false)
            })
        } else {
            $this.addClass('d-none')
            const spinner = $('div[data-for="' + $this.attr('id') + '"]');
            spinner.removeClass('d-none')

            ungift(itemId)
        }
    })

    $(document).on('submit', '#gift-course', function () {
        const sectionInput = $('#gift-section')
        const receiverEmail = $('#receiver_email').val()
        const senderEmail = $('#sender_email').val()

        if (receiverEmail === senderEmail) {
            const warningModal = $("#warning-modal")
            warningModal.find('#warning-modal-text').html('Hai inserito nel campo <strong>"Email del destinatario"</strong> del regalo la tua stessa mail.<br />Non è possibile procedere con il regalo.')
            warningModal.find('#confirm-button').text('Acquisto per me stesso')
            const confirmButton = $('#confirm-button')
            warningModalInstance = new Modal(warningModal)

            modalInstance.hide()
            warningModalInstance.show()

            $(warningModal).on('hidden.bs.modal', function (event) {
                modalInstance.show()
                confirmButton.attr('disabled', false)
            })

            confirmButton.on('click', function (event) {
                confirmButton.find('span').removeClass('d-none')
                confirmButton.attr('disabled', true)
                $('#access-course').submit()
            })

            return false
        }

        if (sectionInput) {
            sectionInput.val(section)
        }

        const submitButton = $(this).find('button[type="submit"]')

        submitButton.find('i').addClass('d-none')
        submitButton.find('span').removeClass('d-none')
        submitButton.attr('disabled', true)

        setTimeout(() => {
            submitButton.find('i').removeClass('d-none')
            submitButton.find('span').addClass('d-none')
            submitButton.attr('disabled', false)
        }, 5000)
    })

    function ungift (itemId) {
        $.ajax({
            url: '/carts/items/' + itemId + '/ungift',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response, status, xhr) {
            location.reload();
        }).fail(function (error) {
            location.reload();
        })
    }

})
